module.exports =
  require('umi-plugin-locale/lib/locale').default ||
  require('umi-plugin-locale/lib/locale');
